import { apiRequest } from '@/lib/api';

export type TemplateCategory = 'ticket' | 'email' | 'pdf';

export type ApiTemplate = {
  id: string;
  companyId: string;
  category: TemplateCategory;
  subType: string;
  name: string;
  isDefault: boolean;
  dataJson: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
};

export function fetchTemplates(filters: { category?: TemplateCategory; subType?: string } = {}) {
  const query = new URLSearchParams();
  if (filters.category) query.set('category', filters.category);
  if (filters.subType) query.set('subType', filters.subType);
  return apiRequest<{ variables: string[]; items: ApiTemplate[] }>(`/templates?${query.toString()}`, {
    method: 'GET',
  });
}

export function createTemplate(payload: {
  category: TemplateCategory;
  subType: string;
  name: string;
  dataJson: Record<string, unknown>;
  isDefault?: boolean;
}) {
  return apiRequest<ApiTemplate>('/templates', {
    method: 'POST',
    body: payload,
  });
}

export function updateTemplate(
  id: string,
  payload: {
    name?: string;
    dataJson?: Record<string, unknown>;
    isDefault?: boolean;
  },
) {
  return apiRequest<ApiTemplate>(`/templates/${id}`, {
    method: 'PATCH',
    body: payload,
  });
}

export function duplicateTemplate(id: string) {
  return apiRequest<ApiTemplate>(`/templates/${id}/duplicate`, {
    method: 'POST',
  });
}

export function setTemplateDefault(id: string) {
  return apiRequest<{ success: boolean }>(`/templates/${id}/set-default`, {
    method: 'POST',
  });
}

export function deleteTemplate(id: string) {
  return apiRequest<{ success: boolean }>(`/templates/${id}`, {
    method: 'DELETE',
  });
}

export function previewTemplate(id: string) {
  return apiRequest<unknown>(`/templates/${id}/preview`, {
    method: 'GET',
  });
}

export function restoreTemplateDefaults(category?: TemplateCategory) {
  return apiRequest<{ success: boolean }>(`/templates/restore-defaults`, {
    method: 'POST',
    body: category ? { category } : {},
  });
}
